import * as React from "react"
import styled from "styled-components"

import Text from "./text.js"

const Styled = styled(Text)`
  display: -webkit-box;
  -webkit-line-clamp: ${props => props.lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const Ellipsis = ({lines = 2, children}) => {
  return <Styled lines={lines}>{children}</Styled>
}

export default Ellipsis
